module.exports = __webpack_public_path__ + "cce80bfe39f637df2d8446d7bb983806.svg";